import { getEpgChannel } from 'services/api/epg/channel';
import { GetEpgVersion, tvEverywhereEnable } from 'utils/getEpgParams';
import m from 'moment';
import { getTimeToEpgChannel } from 'utils/getApisbyAppkey';
import _ from 'lodash';
import {
  FETCH_EPG_CHANNELS_ERROR,
  FETCH_EPG_CHANNELS_INIT,
  FETCH_EPG_CHANNELS_SUCCESS,
} from './constants';
export const fetchEpgChannel = (params = {}, cb) => async (dispatch, getState) => {
  const state = getState();
  let maxTimeshift =
    Math.max(
      ...Object?.values(state?.linealChannel?.data || [])?.map(item => item?.timeshift?.value),
    ) || 6;
  if (maxTimeshift === -Infinity) maxTimeshift = 24;
  const datesRange = {
    TSDateStart: `${m()
      .subtract(24, 'h')
      .format('YYYYMMDDHH')}0000`,
    TSDateEnd: `${m().format('YYYYMMDDHH')}0000`,
    dateStart: `${m().format('YYYYMMDDHH')}0000`,
    dateEnd: `${m()
      .add(24, 'h')
      .format('YYYYMMDDHH')}0000`,
  };

  dispatch({ type: FETCH_EPG_CHANNELS_INIT });
  const appKeyTimeEpgChannel = getTimeToEpgChannel();
  setTimeout(
    () => dispatch(fetchEpgChannel(params)),
    appKeyTimeEpgChannel?.default?.minutes * 60 * 1000,
  );

  const { TSDateEnd, TSDateStart, dateEnd, dateStart } = datesRange;
  try {
    const [epgTSResponse, epgResponse] = await Promise.all([
      getEpgChannel({
        ...params,
        date_from: TSDateStart,
        date_to: TSDateEnd,
      }),
      getEpgChannel({ 
        ...params,
        date_from: dateStart,
         date_to: dateEnd }),
    ]);

    if (epgTSResponse.response && epgTSResponse.response) {
      const { channels: TSChannelEvents } = epgTSResponse.response;
      const { channels: FChannelEvents } = epgResponse.response;
      let matchChannelEvents;

      let epgsMerged = TSChannelEvents.map((channel, index) => {
        matchChannelEvents = FChannelEvents[index].events;
        return {
          ...channel,
          events: [...channel.events, ...matchChannelEvents],
        };
      });

      epgsMerged = epgsMerged.map(c => {
        const events = _.uniqBy(c.events, 'event_alf_id');
        return {
          ...c,
          events: [...events],
        };
      });

      dispatch({
        type: FETCH_EPG_CHANNELS_SUCCESS,
        payload: epgsMerged,
      });
      cb();
    }
  } catch (error) {
    dispatch({
      type: FETCH_EPG_CHANNELS_ERROR,
      error,
    });
  }
};
